import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

platformBrowserDynamic()
    .bootstrapModule(AppModule, {
        ngZoneEventCoalescing: true,
    })
    .catch((err) => console.error(err));

export let deferredPrompt: any = null;

window.addEventListener('beforeinstallprompt', (event: any) => {
    event.preventDefault(); // Prevents the default browser install prompt
    deferredPrompt = event; // Store the event in the global variable
});
